import React from "react";
import ContentCard from "@/components/ContentCard";
import PageLayout from "@/components/PageLayout";

const Contact = () => {
  return (
    <PageLayout
      title="Contact"
      description="Use the GitHub repository for bug reports, feature requests, printer preset corrections, and project discussion."
    >
      <ContentCard title="Best Way To Reach The Project">
        <p>
          Skadisfinity Layout is maintained through GitHub. For public issues,
          printer build-volume corrections, print-profile suggestions, or
          calculation bugs, open an issue in the project repository.
        </p>
        <p>
          Repository:{" "}
          <a
            className="text-blue-600 underline underline-offset-2"
            href="https://github.com/trudrknight/Skadisfinity"
            rel="noreferrer"
            target="_blank"
          >
            github.com/trudrknight/Skadisfinity
          </a>
        </p>
      </ContentCard>

      <ContentCard title="Helpful Details To Include">
        <ul className="list-disc space-y-2 pl-6">
          <li>The layout width and height you entered.</li>
          <li>The printer model or custom build volume used.</li>
          <li>The selected print profile, such as Default or AU3D.</li>
          <li>A screenshot of the results or preview if the layout looks wrong.</li>
        </ul>
      </ContentCard>
    </PageLayout>
  );
};

export default Contact;
